export interface InventoryGeneralInquiryItemDetails {
  name: string;
  qty_on_hand: number;
  qty_available: number;
  qty_reserved: number;
  qty_expected: number;
  min_stock_level: number;
  max_stock_level: number;
  item_group: string;
}

export interface InventoryGeneralInquiryNoOfLocation {
  name: string;
  qty_on_hand: number;
  total_distinct_tags: number;
  total_distinct_serials: number;
}

export interface InventoryAvailByInvStatus {
  description: string;
  qty_on_hand: number;
  total_qty_available: number
}

export interface InventoryCardexInquiry {
  created_at: string,
  description: string,
  inventory_status:string
  event_qty: number,
  prior_qty: number,
  new_qty: number
}

export interface InventoryDetails {
  status_description: string,
  qty_on_hand: number,
  qty_reserved: number,
  lot_number: number,
  tag_number: number,
  serial_number: number,
  name: string
}

export interface ReceivingHistoryData {
  created_at: string,
  id: number,
  supplier_name: string,
  reference_1: string,
  qty_received: number
}
export interface InventoryEventHistoryData {
  created_at: string; // ISO 8601 formatted date string
  user_name: string;
  event_type: string;
  warehouse_location_name: string;
  inventory_status: string;
  lot_number: string;
  tag_number: string | null;
  expiry_date: string; // Date in YYYY-MM-DD format
  serial_number: string | null;
  fifo_date: string | null;
  event_qty: number;
}

export interface WarehouseType {
  id: number;
}
export interface InventoryDetailsTabProps {
  warehouseId: WarehouseType | null;
}
export const TransferHistoryPayload: any = {
  "columns": [
    {
      "data": "stock_transfer_event.created_at"
    },
    {
      "data": "created_by_user.name",
      "as": "user_name"
    },
    {
      "data": "lookup_event.description",
      "as": "event_type"
    },
    {
      "data": "warehouse_location.name",
      "as": "warehouse_location_name"
    },
    {
      "data": "lookup_inventory_status.description",
      "as": "inventory_status"
    },
    {
      "data": "stock_transfer_event.lot_number"
    },
    {
      "data": "stock_transfer_event.tag_number"
    },
    {
      "data": "stock_transfer_event.expiry_date"
    },
    {
      "data": "stock_transfer_event.serial_number"
    },
    {
      "data": "stock_transfer_event.fifo_date"
    },
    {
      "data": "stock_transfer_event.event_qty"
    }
  ]

}
export const ReceivingHistoryPayload: any = {
  "columns": [
    {
      "data": "receipt_detail.created_at"
    },
    {
      "data": "inbound_shipment.id"
    },
    {
      "data": "inbound_shipment_line.id"
    },
    {
      "data": "supplier.name as supplier_name"
    },
    {
      "data": "inbound_shipment.reference_1"
    },
    {
      "data": "receipt_detail.qty_received",
      "func": "sum"
    }
  ],
  // "qty_warehouse_filter": 1
};

export const GeneralInquiryPayload: any = {
  "columns": [
    {
      "data": "warehouse_location.name"
    },
    {
      "data": "inventory.qty_on_hand",
      "func": "sum"
    },
    {
      "data": "total_distinct_tags"
    },
    {
      "data": "total_distinct_serials"
    }
  ],
  // "qty_warehouse_filter": 1
};

export const AvailByInvStatusPayload: any = {
  "columns": [
    {
      "data": "lookup_status.description"
    },
    {
      "data": "inventory.qty_on_hand",
      "func": "sum"
    },
    {
      "data": "total_qty_available"
    }
  ],
  // "qty_warehouse_filter": 1
};

export const InventoryDetailsPayload: any = {
  "columns": [
    {
      "data": "lookup_status.description",
      "as": "status_description"
    },
    {
      "data": "inventory.qty_on_hand"
    },
    {
      "data": "inventory.qty_reserved"
    },
    {
      "data": "inventory.lot_number"
    },
    {
      "data": "inventory.tag_number"
    },
    {
      "data": "inventory.serial_number"
    },
    {
      "data": "warehouse_location.name"
    }
  ],
  // "qty_warehouse_filter": 1
};

export const CardexInquiryPayload: any = {
  "columns": [
    {
      "data": "inventory_user_event.id"
  },
  {
      "data": "inventory_user_event.created_at"
  },
  {
      "data": "lookup_type.description"
  },
  {
      "data": "inventory_status"
  },
  {
      "data": "inventory_user_event.event_qty"
  },
  {
      "data": "prior_qty"
  },
  {
      "data": "new_qty"
  }
  ],
};
